import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeactivatedGuard {
  canDeactivate(): boolean {
    return false;
  }
}
